import * as Yup from 'yup'; 
import { ColDef } from 'ag-grid-community';   
import { CreateExpenseRequest, Expense, UpdateExpenseRequest } from './expense.types'; 
import { expenseApi } from '../../api/accountsApi';
import { FormFieldConfig } from '../../types/formField.types';
import { formatDate, formatDateTime } from '../../utils/date';

export const expenseFormFields: FormFieldConfig[] = [
  { name: 'amount', label: 'Amount', type: 'text', required: true, xs: 24, sm: 3, md: 3, lg: 3, xl: 3 },
  { name: 'date', label: 'Date', type: 'date', required: true, xs: 24, sm: 7, md: 7, lg: 7, xl: 7 },
  { name: 'title', label: 'Title', type: 'text', required: true, xs: 24, sm: 7, md: 7, lg: 7, xl: 7 },
  { name: 'details', label: 'Details', type: 'text', xs: 24, sm: 7, md: 7, lg: 7, xl: 7 },
  { name: 'category', label: 'Quick Category Selection', type: 'select', xs: 24, sm: 12, md: 12, lg: 12, xl: 12, options: [] },
  { name: 'catL1', label: 'Category Level 1', type: 'text', xs: 24, sm: 6, md: 6, lg: 6, xl: 6 },
  { name: 'catL2', label: 'Category Level 2', type: 'text', xs: 24, sm: 6, md: 6, lg: 6, xl: 6 },
  { name: 'catL3', label: 'Category Level 3', type: 'text', xs: 24, sm: 6, md: 6, lg: 6, xl: 6 },
  { name: 'catL4', label: 'Category Level 4', type: 'text', xs: 24, sm: 6, md: 6, lg: 6, xl: 6 },
];

export const expenseFormSchema = Yup.object().shape({
  amount: Yup.number().required('Amount is required'),
  date: Yup.string().required('Date is required'),
  title: Yup.string().required('Title is required'),
});

export const expenseFormInitialValues = (
  data?: Partial<Expense | CreateExpenseRequest | UpdateExpenseRequest> | null
) => ({
  amount: data?.amount || 0,
  date: data?.date ? new Date(data.date).toISOString().split('T')[0] : '',
  title: data?.title || '',
  category: data?.category || '',
  details: data?.details || '',
  catL1: data?.catL1 || '',
  catL2: data?.catL2 || '',
  catL3: data?.catL3 || '',
  catL4: data?.catL4 || '',
});

export const expenseTableColumns: ColDef<Expense>[] = [
  { headerName: 'Amount', field: 'amount', maxWidth:120, minWidth: 120},
  { headerName: 'Date', field: 'date', maxWidth:115, minWidth: 115, valueFormatter: (params) => formatDate(params.value), },
  { headerName: 'Title', field: 'title', minWidth:300 },
  {
    headerName: 'Description',
    field: 'description',
    minWidth: 300,
    valueGetter: (params) => params.data?.description || params.data?.details || '',
  },
  { headerName: 'Category L1', field: 'catL1', minWidth: 150, filter: true },
  { headerName: 'Category L2', field: 'catL2', minWidth: 150, filter: true },
  { headerName: 'Category L3', field: 'catL3', minWidth: 150, filter: true },
  { headerName: 'Category L4', field: 'catL4', minWidth: 150, filter: true },
  {
    headerName: 'Created At',
    field: 'createdAt',
    valueFormatter: (params) => formatDateTime(params.value),
    minWidth: 200,
  },
  { headerName: 'Updated At', field: 'updatedAt', valueFormatter: (params) => formatDateTime(params.value), minWidth: 200 },
];

export const expenseConfig = {
  entityName: 'Expense',
  redirectPath: '/finance/expenses',
  expenseTableColumns,
  api: expenseApi,
};

